import React from 'react';
import './titleCard.css'
const TitleCard = ({value, styleClass}) => {
    return (
        <>
            <h4 className={styleClass}>{value}</h4>
        </>
    );
}

export default TitleCard;
